const article = document.querySelector("article");
window.onload = () => {
  [article.dataset.countUrl, article.dataset.countTagUrl].forEach((url) => {
    if (url) {
      fetch(url, { method: "POST" });
    }
  });
};
